import React, { useRef } from 'react';
import { CheckCircle } from 'lucide-react';
import { motion , useInView } from 'framer-motion';

import './About.css';

const features = [
  "Full Stack Web & Mobile App Developer",
  "Expert in React, Flutter & Firebase ecosystem",
  "Aspiring Data Analyst with Python expertise",
  "Builds scalable cross-platform applications",
  "Passionate about data-driven solutions",
  "Creates responsive and interactive user experiences"
];

function About() {
  const ref = useRef(null);
  const isInView = useInView(ref, { threshold: 0.2 });

  return (
    <motion.section
      id="about"
      ref={ref}
      className="about-section"
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="container">
        <h2 className="section-title">About Me</h2>
        {/* Card with About heading and description */}
        <div className="about-card">
          <p>
            I am a dedicated Full Stack Web and Mobile Application Developer with a passion for Data Analytics. I specialize in building responsive applications across multiple platforms using React, Flutter, and Firebase. As an aspiring Data Analyst, I leverage Python to derive insights from data while creating scalable solutions that deliver exceptional user experiences.
          </p>
        </div>

        {/* Points BELOW the card with alternate sliding */}
        <ul className="about-features">
          {features.map((feature, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              transition={{ duration: 0.6, ease: 'easeOut', delay: 0.2 * index }}
              className="about-feature-item"
            >
              <CheckCircle className="feature-icon" />
              {feature}
            </motion.li>
          ))}
        </ul>
      </div>
    </motion.section>
  );
}

export default About;